import { css } from '@emotion/react';

export const SidebarContent: React.FC = ({ children }) => {
  const styles = css`
    height: calc(100% - 88px);
    overflow-y: auto;
  `;
  return <div css={styles}>{children}</div>;
};
